import {
  Button,
  Group,
  List,
  Loader,
  Modal,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { IconLink } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { trpc } from "../utils/trpc";
import { TextCopier } from "./TextCopier";

interface ReferralModalProps {
  opened: boolean;
  onClose: () => void;
}

export function ReferralModal({ opened, onClose }: ReferralModalProps) {
  const navigate = useNavigate();

  const { data: partner, isPending: isLoadingStatus } =
    trpc.account.createReferralPartner.useQuery(undefined, {
      enabled: opened,
    });

  return (
    <Modal opened={opened} onClose={onClose} title="Referral Program" centered>
      <Stack gap="md">
        {isLoadingStatus && (
          <Stack align="center" py="xl">
            <Loader size="sm" />
          </Stack>
        )}

        {!isLoadingStatus && partner?.referralLink && (
          <>
            <Text fw="bold" size="sm">
              How it works
            </Text>
            <List size="sm" type="ordered">
              <List.Item>Share your invite link</List.Item>
              <List.Item>Your friend gets 20% off for 3 months</List.Item>
              <List.Item>You receive $100 per paying user referred</List.Item>
            </List>

            <TextInput
              description="Your invite link"
              value={partner.referralLink}
              readOnly
              leftSection={<IconLink size={16} />}
              rightSection={<TextCopier content={partner.referralLink} />}
            />

            <Group justify="flex-end">
              <Button variant="default" onClick={onClose}>
                Close
              </Button>
              <Button
                onClick={() => {
                  onClose();
                  navigate("/account/referral");
                }}
              >
                View Dashboard
              </Button>
            </Group>
          </>
        )}
      </Stack>
    </Modal>
  );
}
